import * as types from '../actions';

const initialState = {
  menuActive: 'null',
  assocUserActive: 0,
  loginAsDataStatus: '',
  loginAsUserResponse: [],
  loginAsUserStatus: '',  
  loginAsUserActivity: '',
  fromDashboard: false,
  fromReport: false,
  fromExpiryCertificatesWindow: false,
  fromClientDashboardQuote: false,
  fromClientDashboardEvent: false,
  fromClientDashboardCompletedEvent: false,
  fromActionRequired: false,
  fromDashboardShiftTimeChangeRequest: false,
  shiftTitle: '',
  feedbackTitle: '',
  crewListTitle: '',
  timesheetDateTitle: '',
};

export default function(state = initialState, action) {
  const response = action.data;
  let timeVar = '~~'+Date.now(); 
  switch(action.type) {    

    case types.FILTERBY_TOGGLE:
      return { ...state, 
        isFilterOn:response
      };  
    
    case types.MENU_ACTIVE:  
      return {
          ...state,
          menuActive:response
      }

    case types.FROM_DASHBOARD: 
      return {
          ...state,
          fromDashboard:response
      }
    case types.FROM_REPORT: 
      return {
          ...state,
          fromReport:response
      }
    case types.TIMESHEET_DATE_HEADER: 
      return {
          ...state,
          timesheetDateTitle:response
      }
    case types.FROM_EXPIRY_CERTIFICATES: 
      return {
          ...state,
          fromExpiryCertificatesWindow:response
      }

    case types.FROM_CLIENT_DASHBOARD_QUOTES:
      return {
          ...state,
          fromClientDashboardQuote:response
      }

    case types.FROM_CLIENT_DASHBOARD_EVENTS: 
        return {
          ...state,
          fromClientDashboardEvent:response
      }
    case types.FROM_DASHBOARD_SHIFT_TIME_CHANGE: 
        return {
          ...state,
          fromDashboardShiftTimeChangeRequest:response
      }
    case types.FROM_CLIENT_DASHBOARD_COMPLETED_EVENTS: 
            return {
              ...state,
              fromClientDashboardCompletedEvent:response
          }

    case types.FROM_ACTION_REQUIRED: 
      return {
          ...state,
          fromActionRequired:response
      }

    case types.SHIFT_TITLE: 
      return {
          ...state,
          shiftTitle:response
      }

    case types.FEEDBACK_TITLE: 
      return {
          ...state,
          feedbackTitle:response
      }
      case types.CREW_LIST_TITLE: 
      return {
          ...state,
          crewListTitle:response
      }

    case types.MENU_DEACTIVE:
      return { ...state, 
        menuActive:response
      };  
    
    case types.ASSOC_USER_ACTIVE:  
      return {
          ...state,
          assocUserActive:response
      }
    
    case types.ASSOC_USER_DEACTIVE:  
      return {
          ...state,
          assocUserActive:response
      }
    
    case types.LOGIN_AS_SET_DATA: 
      return {
          ...state,
          loginAsData:response,
          loginAsDataStatus: types.LOGIN_AS_SET_DATA 
      }  
    case types.LOGIN_AS_RESET_DATA: 
      return {
          ...state,
          loginAsData:response,
          loginAsDataStatus: types.LOGIN_AS_RESET_DATA
      }   

    case types.LOGIN_AS_USER_SUCCESS:  
      if(action.response.data.status && action.response.data.status===200){
        return {
            ...state, 
            loginAsUserResponse: action.response.data ? action.response.data : [],
            loginAsUserStatus: action.response.data.status ? action.response.data.status : '',  
            loginAsUserActivity:types.LOGIN_AS_USER_SUCCESS+timeVar,  
        } 
      }
      else {
        return {
          ...state,
          loginAsUserErrorData: action.response.data ? action.response.data : [],
          loginAsUserStatus: action.response.data.status ? action.response.data.status : '',  
          loginAsUserActivity:types.LOGIN_AS_USER_ERROR+timeVar,  
        }
      }
    case types.LOGIN_AS_USER_ERROR: 
      return {
        ...state,
        loginAsUserErrorData: action.response.data ? action.response.data : [],
        loginAsUserStatus: action.response.status ? action.response.status : '',  
        loginAsUserActivity:types.LOGIN_AS_USER_ERROR+timeVar,  
      }    


    case types.INVITE_AS_FRIEND_SUCCESS:  
      if(action.response.status && action.response.status===200){
        return {
            ...state, 
            inviteAsFriendResponse: action.response.data ? action.response.data : [],
            inviteAsFriendStatus: action.response.status ? action.response.status : '',  
            inviteAsFriendActivity:types.INVITE_AS_FRIEND_SUCCESS+timeVar,  
        } 
      }
      else {
        return {
          ...state,
          errorData: action.response.data ? action.response.data : [],
          inviteAsFriendStatus: action.response.status ? action.response.status : '',  
          inviteAsFriendActivity:types.INVITE_AS_FRIEND_ERROR+timeVar,  
        }
      }
    
    case types.INVITE_AS_FRIEND_ERROR:  
      return {
          ...state,
          errorData: action.response.data ? action.response.data : [],
          inviteAsFriendStatus: action.response.status ? action.response.status : '',  
          inviteAsFriendActivity:types.INVITE_AS_FRIEND_ERROR+timeVar,  
      }


    default:
      return state;
  }
};